module.exports = __webpack_public_path__ + "img/list3.d26048ce.jpg";